<app-navbar-style-three></app-navbar-style-three>

<section class="administration-section">
  <div class="container">
    <div class="section-header">
      <h1 class="section-header__title">All Chief Patrons</h1>
    </div>

    <div class="administration-content" *ngIf="!fetchinData">
      <div class="empty-state" *ngIf="ChiefPatrons == null || ChiefPatrons.length === 0">
        <svg class="empty-state__icon" width="80" height="80" viewBox="0 0 24 24" fill="none">
          <path
            d="M22 10V6C22 5.46957 21.7893 4.96086 21.4142 4.58579C21.0391 4.21071 20.5304 4 20 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V10"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M2 10H22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 14V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <p class="empty-state__text">No chief patrons available</p>
      </div>

      <div class="row justify-content-center" *ngIf="ChiefPatrons != null && ChiefPatrons.length > 0">
        <div class="col-md-10 mb-5" *ngFor="let item of ChiefPatrons; let i = index" [attr.data-index]="i">
          <div class="text-center mb-4">
            <h2
              style="color: #003366; font-weight: 700; font-size: 32px; border-bottom: 2px solid #003366; display: inline-block; padding-bottom: 10px;">
              {{ item.TitleEn }}</h2>
          </div>
          <div class="card shadow-sm border-0" style="border-radius: 12px; overflow: hidden; background: #fff;">
            <img [src]="item.FilePath || item.imageUrl || (item.ShowAttachments && item.ShowAttachments.length > 0 ? item.ShowAttachments[0].FilePath : '')" [alt]="item.TitleEn" class="img-fluid w-100"
              style="height: auto;" loading="lazy" />
            <div class="card-body p-4 p-md-5">
              <div class="card-text text-muted" [innerHTML]="item.DetailsEn"
                style="font-size: 17px; line-height: 1.8; color: #444;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-state" *ngIf="fetchinData">
      <div class="loading-grid">
        <div class="skeleton skeleton--content">
          <div class="skeleton__header"></div>
          <div class="skeleton__line" *ngFor="let i of [1,2,3,4,5,6]"></div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>